import React from 'react';
import Select from '@atlaskit/select';
import Tooltip from '@atlaskit/tooltip';
import { useIntl } from '@atlassian/jira-intl';
import { FieldContainer } from '@atlassian/jira-issue-create-commons/src/common/ui/fields/styled.tsx';
import { withFormField } from '@atlassian/jira-issue-create-commons/src/common/ui/with-form-field/index.tsx';
import { closeMenuOnScroll } from '@atlassian/jira-issue-create-commons/src/common/utils/select/index.tsx';
import { formatOptionLabel } from '@atlassian/jira-issue-field-select-base/src/ui/format-option-label/index.tsx';
import { defaultSelectStyles } from '@atlassian/jira-issue-field-select-base/src/ui/react-select-styles/styled.tsx';
import messages from './messages.tsx';
import type { Props, SelectFieldConfig, FieldValue } from './types.tsx';
import { mapOptionsToData, mapOptionToData } from './utils.tsx';

const SecurityLevelField = (props: Props) => {
	const { formatMessage } = useIntl();
	const {
		fieldId,
		fieldProps: { value = [], onChange, ...fieldProps },
		error,
		allowedValues,
		width,
		autoFocus = false,
		onCloseMenuOnScroll = closeMenuOnScroll,
		isDropdownMenuFixedAndLayered = false,
		isEditable = true,
		nonEditableReason,
		inputId,
	} = props;
	const option = mapOptionsToData(allowedValues);
	const isInvalid = Boolean(error);

	const getSecurityLevelField = () => (
		<Select
			inputId={inputId}
			{...fieldProps}
			options={option}
			// @ts-expect-error - TS2322 - Type '(value: SecurityLevelOption) => void' is not assignable to type '(value: Option | null, action: ActionMeta<Option>) => void'.
			onChange={onChange}
			value={value}
			placeholder={formatMessage(messages.securityLevelFieldPlaceHolder)}
			isClearable
			formatOptionLabel={formatOptionLabel}
			menuPosition={isDropdownMenuFixedAndLayered === true ? 'fixed' : undefined}
			// eslint-disable-next-line @atlaskit/design-system/no-unsafe-style-overrides -- Ignored via go/DSP-18766
			styles={defaultSelectStyles}
			hideSelectedOptions={false}
			isMulti={false}
			autoFocus={autoFocus}
			// @ts-expect-error - TS2322 - Type '"error" | null' is not assignable to type 'ValidationState | undefined'.
			validationState={isInvalid === true ? 'error' : null}
			classNamePrefix={`select-${fieldId}`}
			// @ts-expect-error - TS2322 - Type '(e: ChangeEvent<HTMLElement>) => boolean' is not assignable to type 'boolean | EventListener | undefined'.
			closeMenuOnScroll={onCloseMenuOnScroll}
			isDisabled={isEditable === false}
		/>
	);

	return (
		<FieldContainer width={width}>
			{isEditable === false ? (
				<Tooltip content={nonEditableReason?.message || ''}>{getSecurityLevelField()}</Tooltip>
			) : (
				getSecurityLevelField()
			)}
		</FieldContainer>
	);
};

// eslint-disable-next-line @atlassian/eng-health/no-barrel-files/disallow-reexports
export { transformOnSubmit, mutateSecurityLevelField } from './utils';
export default withFormField({
	transformDefaultValue: mapOptionToData,
	// @ts-expect-error - TS2345 - Argument of type '(props: Props) => JSX.Element' is not assignable to parameter of type 'AbstractComponent<ComponentProps<SelectFieldConfig, SecurityLevelOption>, any>'.
})<SelectFieldConfig, FieldValue>(SecurityLevelField);
